import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAddPartnerModal } from '../context/AddPartnerModalContext';

const AddPartnerModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useAddPartnerModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('AddPartner')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddPartnerModalHeader;
